export default __webpack_public_path__ + "static/media/mailW.8d3cdbf6.svg";